import { combineReducers } from 'redux';
import auth from './authReducer';
import loginReducer from './loginReducer';
import intercomReducer from "./intercomReducer";
import usersReducer from './usersReducer';
import companiesReducer from './companiesReducer';
import freeTrialsReducer from './freeTrialsReducer';

const reducers = function (store: any = {}, action: any) {
  return {
    auth: auth(store.auth, action, store),
    login: loginReducer(store.login, action, store),
    intercom: intercomReducer(store.intercom, action, store),
    users: usersReducer(store.users, action, store),
    companies: companiesReducer(store.companies, action, store),
    freeTrials: freeTrialsReducer(store.freeTrials, action, store),
  }
}

export default reducers